import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxDataGridModule } from 'devextreme-angular';

import { Observable, map } from 'rxjs';

import { OptimisationComparisonsService } from './optimisation-comparisons.service';

import { OptimisationChanges } from './optimisation-changes.model';

@Component({
	selector: 'app-optimisation-comparisons',
	templateUrl: './optimisation-comparisons.component.html',
	standalone: true,
	imports: [
		CommonModule,
		DxDataGridModule
	]
})
export class OptimisationComparisonsComponent implements OnInit {
	dateTimeFormat = "dd-MMM-yyyy HH:mm:ss";
	/** Phones: no group panel (it overlaps the search there); grouping is still on the column menu. */
	readonly phone = matchMedia('(max-width: 640px)').matches;

	opimisationChanges$?: Observable<OptimisationChanges[]>;

	constructor(private optimisationComparisonsService: OptimisationComparisonsService) { }

	ngOnInit() {
		this.opimisationChanges$ = this.optimisationComparisonsService.get().pipe(map((optimisationComparisons) => 
			optimisationComparisons.flatMap((optimisationComparison) => 
				optimisationComparison.parameterComparisons.map((parameterComparison) => {
					return {
						optimisationComparisonId: optimisationComparison.optimisationComparisonId,
						comparisonDate: optimisationComparison.comparisonDate,
						changeDate: optimisationComparison.comparisonDate,
						initiatedBy: optimisationComparison.initiatedBy,
						beforeFile: optimisationComparison.beforeFile.split('\\').at(-1),
						afterFile: optimisationComparison.afterFile.split('\\').at(-1),
						changeType: parameterComparison.changeType,
						source: parameterComparison.source,
						description: parameterComparison.description,
						tradeId: parameterComparison.tradeId,
						allegroId:parameterComparison.allegroId,
						field:parameterComparison.field,
						beforeValue:parameterComparison.beforeValue,
						afterValue:parameterComparison.afterValue,
						remarks:parameterComparison.remarks
					} as OptimisationChanges;
					}))));
		}
}
